var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.contentType == 'budget')?_c('BudgetDetailComponent',{attrs:{"budgetId":_vm.contentId}}):(_vm.contentType == 'chatroom')?_c('MessagesFullView',{attrs:{"selectedChatRoomId":_vm.contentId}}):(_vm.isContractType)?_c('ContractDetailComponent',{attrs:{"contractId":_vm.contentId,"contractType":_vm.contentType}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }